// DwsDateTimePicker key defaults. The core's delegated keydown handlers ("datetime-input", "datetime-nav") call these
// synchronously, inside the key event, so they must not go through a lazily loaded module's stand-in (which answers
// with a promise, after the default already happened): the core imports them from here. The "pickers" module also
// publishes them under their old global names.

/**
 * The keys that open DwsDateTimePicker's popup from its field (Alt+ArrowDown; Enter, Space and ArrowDown with
 * OnlyDialog) also scrolled the page by default, and the scroll closed the popup they had just opened. Wired on the
 * picker's root (the field's own onkeydown belongs to .NET); acts only on keys pressed in the field.
 */
export function DwsDateTimePickerInputKeyDown(event: KeyboardEvent, onlyDialog: boolean): void {
    const input = event.target as HTMLElement | null;

    if (!input || !input.classList || !input.classList.contains("dws-datetimepicker__input")) {
        return;
    }

    const opens = (event.altKey && event.key === "ArrowDown")
        || (onlyDialog && (event.key === "Enter" || event.key === " " || event.key === "ArrowDown" || event.key === "ArrowUp"));

    if (opens) {
        event.preventDefault();
    }
}

/**
 * The popup's month grid and hour / minute lists move focus with the arrow keys, Page Up / Down and Home / End, and
 * pick with Enter / Space, all handled in .NET. This stops those keys from also scrolling the page or a list, or
 * clicking the focused button; Blazor's @onkeydown:preventDefault cannot depend on the key.
 */
export function DwsDateTimePickerNavKeyDown(event: KeyboardEvent): void {
    const target = event.target as Element | null;
    const item = target && target.closest ? target.closest("[data-dws-nav]") : null;

    if (!item) {
        return;
    }

    const navigation = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"];
    // .NET picks the item it knows is focused: an Enter pressed before the focus has followed an arrow key (a slow
    // connection) would otherwise click the button that still has it.
    const activates = event.key === " " || event.key === "Enter";

    if (navigation.indexOf(event.key) >= 0 || activates) {
        event.preventDefault();
    }
}
